import { useParams } from 'react-router-dom';

type usePolicyParamsType = {
  policyId: string;
  draftId?: string;
  termNumber?: string;
};

/**
 * Returns the current policy's policy id and termNumber from the URL params.
 * @return {usePolicyParamsType}
 */
export const usePolicyParams: () => usePolicyParamsType = () => {
  const {
    id: policyId,
    draftId,
    termNumber,
  } = useParams<{
    id: string;
    draftId?: string;
    termNumber?: string;
  }>();
  return {
    policyId,
    draftId,
    termNumber,
  };
};
